import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { LoadingController } from 'ionic-angular';

@Injectable()
export class LoaderProvider {

  constructor(public http: Http, public loadingCtrl: LoadingController) {

  }

  loading: any;

  show(message: string = 'Aguarde...') {
    if(!this.loading){
        this.loading = this.loadingCtrl.create({
            content: message
        });
        this.loading.present();
    }
  }

  hide() {
    if(this.loading){
        this.loading.dismiss();
        this.loading = null;
    }
  }

}


// WEBPACK FOOTER //
// ./src/providers/loader.ts